import { useMemo } from 'react';
import type { Epic } from '../../../../../api/tasks-client/task-client.type';
import { useCostTabStore } from '../../../../../store/strategy-store/strategy-store';
import { searchEpics } from '../../initiative-performance.helpers';
import { useCostEpics } from '../cost-tab.hooks';

/**
 * Hook that returns filtered and sorted epics based on user-selected criteria
 *
 * @returns {Epic[] | []} Filtered and sorted array of epics
 */
const useFilteredEpics = (): Epic[] | [] => {
  const epics = useCostEpics();

  const searchTerm = useCostTabStore((state) => state.filterControls.searchTerm);
  const sortBy = useCostTabStore((state) => state.filterControls.sortBy);
  const sortDirection = useCostTabStore((state) => state.filterControls.sortDirection);
  const hideEmpty = useCostTabStore((state) => state.filterControls.hideEmpty);

  const processedEpics = useMemo(() => {
    if (!epics.length) {
      return [];
    }

    const result = searchEpics(epics, { searchTerm, sortBy, sortDirection, hideEmpty });

    return result;
  }, [epics, searchTerm, sortBy, sortDirection, hideEmpty]);

  return processedEpics;
};

export { useFilteredEpics };
